import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { Text, TextType } from 'ui-components/components/text';

import messages from '../../messages';
import style from './delete-modal.module.less';

const DeleteModal = ({ inventoryWarehouseName = '', inventoryWarehouseLocationId, onDelete }) => {
  const isDeletingLocation = !!inventoryWarehouseLocationId;
  const onDeleteInventoryWarehouseLocation = useCallback(
    () => onDelete(inventoryWarehouseLocationId),
    [inventoryWarehouseLocationId, onDelete],
  );
  const onDeleteClick = isDeletingLocation ? onDeleteInventoryWarehouseLocation : onDelete;

  return (
    <Modal size='medium'>
      <ModalHeader>
        <FormattedMessage
          {...(isDeletingLocation ? messages.deleteLocationConfirmationModalTitle : messages.deleteWarehouseConfirmationModalTitle)}
        />
      </ModalHeader>
      <ModalBody className={style.body}>
        {isDeletingLocation ? (
          <Text textType={TextType.Paragraph} value={messages.deleteLocationConfirmationMessage} />
        ) : (
          <>
            <Text textType={TextType.Paragraph} value={messages.deleteWarehouseConfirmationHeader} />
            <ul className={style['warehouse-delete-confirmation-list']}>
              <li>
                <FormattedMessage {...messages.deleteWarehouseConfirmationUnassignStock} values={{ inventoryWarehouseName }} />
              </li>
              <li>
                <FormattedMessage {...messages.deleteWarehouseConfirmationRemoveInventory} values={{ inventoryWarehouseName }} />
              </li>
              <li>
                <FormattedMessage {...messages.deleteWarehouseConfirmationDeleteLocations} values={{ inventoryWarehouseName }} />
              </li>
            </ul>
          </>
        )}
        <Text className={style['are-you-sure']} textType={TextType.Paragraph} value={messages.deleteWarehouseConfirmationFooter} />
      </ModalBody>
      <ModalFooter>
        <ModalFooterCancelButton />
        <Button onClick={onDeleteClick} theme='danger'>
          <FormattedMessage {...messages.deleteWarehouseModalDeleteButton} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteModal.propTypes = {
  inventoryWarehouseName: PropTypes.string,
  inventoryWarehouseLocationId: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteModal;
